// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"curve"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M2 11.7576C2 9.33333 4.31081 4 6.62162 4C8.93243 4 10.9865 8.84848 11.5 11.7576C11.8851 14.3434 14.1892 20 16.5 20C18.8108 20 21 14.6667 21 11.7576","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M15 12H18M5 12H8","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-curve')
export default class CurveIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'curve',
    }
  }
}
